(function () {
  function destroySwiper(sectionId) {
    var key = 'hcSwiper_' + sectionId;
    var inst = window[key];
    if (inst && typeof inst.destroy === 'function') inst.destroy(true, true);
    window[key] = null;
  }

  function initSwiper(sectionId) {
    var key = 'hcSwiper_' + sectionId;
    if (window[key]) return;
    var el = document.getElementById('hc-swiper-' + sectionId);
    if (!el) return;

    if (typeof window.Swiper === 'undefined') {
      setTimeout(function () { initSwiper(sectionId); }, 50);
      return;
    }

    window[key] = new Swiper(el, {
      slidesPerView: 1.5,
      spaceBetween: 22,
      centeredSlides: false,
      loop: true,
      speed: 500,
      autoplay: false,
      navigation: {
        nextEl: document.getElementById('hc-next-' + sectionId),
        prevEl: null
      },
      breakpoints: {
        480: { slidesPerView: 2.8, spaceBetween: 16 },
        769: { slidesPerView: 4.2, spaceBetween: 20 },
        1025: { slidesPerView: 5.2, spaceBetween: 20 },
        1280: { slidesPerView: 5.4, spaceBetween: 22 }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hc-section]').forEach(function (root) {
      initSwiper(root.dataset.hcSection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail) destroySwiper(e.detail.sectionId);
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail) { destroySwiper(e.detail.sectionId); initSwiper(e.detail.sectionId); }
  });
})();
